import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '@/components/site/Header';
import { Footer } from '@/components/site/Footer';
import { ScrollProgress } from '@/components/site/ScrollProgress';
import { Seo } from '@/components/site/Seo';
import { useLenis, scrollToTop } from '@/hooks/useLenis';

export function Layout({ children }) {
  useLenis();
  const location = useLocation();

  useEffect(() => {
    // Stop browser restoring old scroll position on navigation
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    // Scroll to top on route change (or to hash target)
    if (location.hash) {
      const id = location.hash.replace('#', '');
      // Defer to next frame so target exists
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          scrollToTop();
        }
      });
    } else {
      scrollToTop();
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen flex flex-col bg-ink-bg text-ink-text">
      <Seo />
      <ScrollProgress />
      <Header />
      <main className="flex-1 pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
}
